@if (error) {
  <div class="notification-div">
    @switch (error) {
      @case (AppErrorCode.LOADING_ERROR) {
        <app-notification-content
          [icon]="SvgIcon.TOWER_CELL"
          [text]="'notifications.loadingFailure.text' | translate"
          [buttonText]="'notifications.loadingFailure.buttonText' | translate"
          (buttonClicked)="click()"
        ></app-notification-content>
      }
      @default {
        <app-notification-content
          [icon]="SvgIcon.FACE_SAD_TEAR"
          [text]="'notifications.error.text' | translate"
          [buttonText]="'notifications.loadingFailure.buttonText' | translate"
          (buttonClicked)="click()"
        ></app-notification-content>
      }
    }
  </div>
}

